import { useAuthStore } from './auth-store';

/**
 * Optional modules a site turns on by listing them in the API's `BizWebSettings:SpecialModules` (BW-8453). The list
 * reaches the admin as the login `spmods` (`usrs_spmods`, parsed into `session.specialModules`); names match exactly.
 */
export const APPOINTMENTS_MODULE = 'Appointments';
export const CONTESTS_MODULE = 'Contests';
/** Ready-made wishlists (wishlist templates, BW-8477). */
export const WISHLIST_TEMPLATES_MODULE = 'WishlistTemplates';

/**
 * Whether the signed-in session lists `name` among its special modules. Synchronous (read from the stored session),
 * so a module's menu entries and routes never flash in while a request is in flight; updates on login, refresh and
 * logout like `useHasAccess`. admin-v2 keeps its session in `useAuthStore`; the legacy admin's AuthProvider-based
 * hook of the same name (`Core/client/admin/src/shared/auth/react`) does not apply here.
 */
export function useHasSpecialModule(name: string): boolean {
	return useAuthStore(s => s.session?.specialModules?.includes(name) ?? false);
}
